var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBuildingColorful = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 168 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.8164 1V21.7285H1V98.5397H52.9273H104.515H166.493V21.7285H118.585V1H48.8164Z",
    fill: "#383E41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8818 10.918H77.4246V22.0522L64.9115 22.084L64.8818 10.918Z",
    fill: "#0084F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.226 10.918L102.26 21.9631L89.8336 22.0162L89.7891 10.918H102.226Z",
    fill: "#0084F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.226 10.918L102.26 21.9631L89.8336 22.0162L89.7891 10.918H102.226Z",
    fill: "#0084F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.562 37.2617H129.128V48.4151L116.562 48.4469V37.2617Z",
    fill: "#0084F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.225 37.2617L102.259 48.309L89.8438 48.3557V37.2617H102.225Z",
    fill: "#0084F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8818 37.2617H77.4246V48.3981L64.9115 48.4257L64.8818 37.2617Z",
    fill: "#0084F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1816 37.2617H50.6289L50.6607 48.2984L38.2241 48.3472L38.1816 37.2617Z",
    fill: "#0084F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.471 37.2617H154.022V48.3429L141.471 48.3811V37.2617Z",
    fill: "#0084F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1406 37.2617H25.5879L25.6176 48.2984L13.1809 48.3472L13.1406 37.2617Z",
    fill: "#0084F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.471 37.2617H154.022V48.3429L141.471 48.3811V37.2617Z",
    fill: "#0084F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1406 37.2617H25.5879L25.6176 48.2984L13.1809 48.3472L13.1406 37.2617Z",
    fill: "#0084F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.562 59.8086H129.128V70.9619L116.562 70.9937V59.8086Z",
    fill: "#C3C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.225 59.8086L102.259 70.8559L89.8438 70.9025V59.8086H102.225Z",
    fill: "#C3C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.8818 59.8086H77.4246V70.945L64.9115 70.9725L64.8818 59.8086Z",
    fill: "#C3C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1816 59.8086H50.6289L50.6607 70.8453L38.2241 70.894L38.1816 59.8086Z",
    fill: "#C3C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.471 59.8086H154.022V70.8898L141.471 70.9259V59.8086Z",
    fill: "#0084F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1406 59.8086H25.5879L25.6176 70.8453L13.1809 70.894L13.1406 59.8086Z",
    fill: "#0084F8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.471 59.8086H154.022V70.8898L141.471 70.9259V59.8086Z",
    fill: "#C3C5C5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1406 59.8086H25.5879L25.6176 70.8453L13.1809 70.894L13.1406 59.8086Z",
    fill: "#C3C5C5"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBuildingColorful, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/buildingColorful.51665d51.svg";
export { ForwardRef as ReactComponent };